import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeSEMContainer from 'containers/dashboards/LayerThreeSEMContainer';
import LayerTwoSEMContainer from 'containers/dashboards/LayerTwoSEMContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForRange } from 'helpers/range';

const SEMDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)}/>}>

        <DetermineLayerContainer
            layerTwo={LayerTwoSEMContainer}
            layerThree={LayerThreeSEMContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'SEM' }),
    PageView({ page: 'Viewed Entity SEM', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({

        params: {
            ...getQueryParamDefForRange()
        },
        initialTruth: 'location',
    }),
)(SEMDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/SEM.js